import { useCoursesStore } from '~~/stores/courses'

export default function useJwPlayer() {
  const coursesStore: Record<string, any> = useCoursesStore()
  const courseDetail = computed(() => coursesStore?.state?.courseDetail)
  const previewThumbnail = ref(false)

  const setupJwPlayer = (id: string) => {
    if (process.client) {
      if (window.jwplayer(id)) {
        const jwplayer = ref(window.jwplayer(id))

        const configJwPlayer = {
          playlist: `https://cdn.jwplayer.com/v2/media/${courseDetail.value?.data?.videoPreviewAttachmentMetadata?.mediaID}`,
          sharing: { sites: ['facebook', 'twitter', 'linkedin'] },
          intl: {
            en: {
              sharing: {
                heading: 'Share this video'
              }
            }
          }
        }
        jwplayer.value.setup(configJwPlayer)
      }
    }
  }

  return {
    previewThumbnail,
    setupJwPlayer
  }
}
